import axios from 'axios';
import URLs from '@/config/constants';
// eslint-disable-next-line import/prefer-default-export
export const GetDataBeneficiary = async ({ rut, token }) => axios.create({
  baseURL: `${URLs.GetDataBeneficiary}?rutBeneficiary=${rut}`,
  timeout: 180000,
  headers: {
    Authorization: token,
  },
}).get().then((resp) => {
  if (resp.status === 200) { return Promise.resolve(resp); }
  const responde = { response: { status: resp.status } };
  return Promise.reject(responde);
});
